import Image from 'next/image';
import clsx from 'clsx';

export default function PropsBanner({ block, position }) {
  const { background_color_picker, text_color, props, uid } =
    block.props_banner.reference[0];

  return (
    <section
      id={`${uid}_${position}`}
      data-name="props_banner"
      className={clsx(
        'px-15 py-0 sm:py-5',
        background_color_picker && `bg-[${background_color_picker}]`,
        text_color && `text-[${text_color}]`
      )}
    >
      <div className="grid grid-cols-1 justify-items-start gap-2 py-5 sm:grid-cols-2 sm:gap-5 sm:py-0 lg:flex lg:flex-row lg:items-center lg:justify-center lg:gap-14">
        {props.map((item, index) => {
          const image = item.image;

          return (
            <div
              key={item._metadata.uid || index}
              data-count={index}
              className="flex h-full items-center gap-2"
            >
              {image.url &&
                image.dimension?.width &&
                image.dimension?.height && (
                  <Image
                    id={`${uid}_${item._metadata.uid}`}
                    src={image.url}
                    alt={image.title || item.copy}
                    width={image.dimension.width}
                    height={image.dimension.height}
                    sizes="56px"
                    className="h-auto w-14 shrink-0"
                  />
                )}
              <h2 className="h6 sm:h5">{item.copy}</h2>
            </div>
          );
        })}
      </div>
    </section>
  );
}
